/**
 * @param {Array<{top:number, bottom:number, height:number}>} rects
 * @param {number} viewportHeight
 * @param {{eps?:number, maxRatio?:number}} [opts]
 * @returns {number}  底部被遮蔽的最大高度(px,非負整數)
 */
export function bottomOverlapPx(rects, viewportHeight, opts = {}) {
    const eps = opts.eps ?? 2;
    const maxRatio = opts.maxRatio ?? 0.4;
    let max = 0;
    for (const rect of rects) {
        if (rect.height <= 0) continue;
        if (rect.bottom < viewportHeight - eps) continue;
        const overlap = viewportHeight - rect.top;
        if (overlap > max) max = overlap;
    }
    const cap = viewportHeight * maxRatio;
    return Math.min(Math.max(max, 0), cap);
}

/**
 * @param {number[]} heights  由下而上各元素高度;0 代表該元素不存在/隱藏
 * @param {{base:number, gap:number}} opts
 * @returns {number[]}  與 heights 等長的 slot 偏移量
 */
export function stackSlots(heights, opts) {
    const { base, gap } = opts;
    if (heights.length === 0) return [];

    const slots = new Array(heights.length);
    let cursor = base;
    let sawVisible = false;

    for (let i = 0; i < heights.length; i++) {
        if (i === 0) {
            slots[0] = base;
        } else if (heights[i] === 0) {
            slots[i] = slots[i - 1];
        } else {
            slots[i] = sawVisible ? cursor : base;
        }

        if (heights[i] > 0) {
            cursor = slots[i] + heights[i] + gap;
            sawVisible = true;
        }
    }

    return slots;
}
